import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchOrgSampleWeddingStatus } from 'apollo/projects.query';

import Cards from 'components/Cards';
import TypeCard from 'components/Cards/TypeCard';

import selectTypeImage0 from 'assets/images/projects/haute-stock-photography-wedding-collection-final-48-small.jpg';
import selectTypeImage1 from 'assets/images/projects/haute-stock-photography-wedding-collection-final-40-small.jpg';
import selectTypeImage2 from 'assets/images/projects/haute-stock-photography-glam-nye-final-18-small.jpg';
import selectTypeImage3 from 'assets/images/projects/haute-stock-photography-wedding-collection-final-20-small.jpg';
import './styles.scss';

const CreateQuickProject = ({ type, updateType, openCreateProject }) => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const userId = userInfo.id;
  const { ownerId } = userInfo.organization;
  const [sampleWeddingStatus, setSampleWeddingStatus] = useState('');
  const [isFormLoaded, setFormLoaded] = useState(false);
  const bottomRef = useRef(null);

  const canCreateSample = sampleWeddingStatus === 'available' || sampleWeddingStatus === 'preparing';

  useEffect(() => {
    const getSampleWeddingStatus = async () => {
      try {
        const dataStatus = await fetchOrgSampleWeddingStatus();
        setSampleWeddingStatus(dataStatus.me.organization.sampleWeddingStatus);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
      setFormLoaded(true);
    };
    getSampleWeddingStatus();
  }, []);

  useEffect(() => {
    if (type !== -1) bottomRef.current?.scrollIntoView({ bottomRef: 'smooth' });
  }, [type]);

  const handleProjectCreateValidation = () => {
    if (type === -1) {
      return false;
    }
    return true;
  };

  const handleProjectCreate = () => {
    if (handleProjectCreateValidation()) {
      openCreateProject();
    }
  };

  const desc1 = 'Dive into this sample wedding and explore Aisle Planner\'s planning tools in action.';
  const desc2 = `Streamline planning, collaborate with your team and
    clients, and manage every wedding detail along the way.`;
  const desc3 = `From social events to corporate galas to mitzvahs
    and everything in between, you can plan it all right here.`;
  const desc4 = `Plan anything on Aisle Planner with customizable
    tools that help you stay perfectly organized and on track.`;

  return (
    <>
      {isFormLoaded && (
        <>
          <h4 className="cards-container__subtitle">
            Select a project type
          </h4>
          <Cards>
            {userId === ownerId && canCreateSample && (
              <TypeCard
                selected={type === 0}
                name="new-project"
                title="Sample Wedding"
                desc={desc1}
                img={{
                  imgUrl: selectTypeImage0,
                  alt: 'Sample Wedding',
                }}
                onClick={() => updateType(0)}
              />
            )}
            <TypeCard
              selected={type === 1}
              name="new-project"
              title="Wedding"
              desc={desc2}
              img={{
                imgUrl: selectTypeImage1,
                alt: 'Wedding',
              }}
              onClick={() => updateType(1)}
            />
            <TypeCard
              selected={type === 2}
              name="new-project"
              title="Event"
              desc={desc3}
              img={{
                imgUrl: selectTypeImage2,
                alt: 'Event',
              }}
              onClick={() => updateType(2)}
            />
            <TypeCard
              selected={type === 3}
              name="new-project"
              title="Other Project"
              desc={desc4}
              img={{
                imgUrl: selectTypeImage3,
                alt: 'Other project',
              }}
              onClick={() => updateType(3)}
            />
          </Cards>
          <button
            className={`create_quick_project_modal__create button modal__${
              type > -1 ? 'active' : 'inactive'
            }`}
            onClick={handleProjectCreate}
          >
            Create project
          </button>
          <div ref={bottomRef} />
        </>
      )}
    </>
  );
};

CreateQuickProject.propTypes = {
  type: PropTypes.number,
  updateType: PropTypes.func.isRequired,
  openCreateProject: PropTypes.func.isRequired,
};

CreateQuickProject.defaultProps = {
  type: -1,
};

export default CreateQuickProject;
